import * as type from './types';

export function getServiceTypes(data) {
    return {
        type: type.GET_SERVICE_TYPES_REQUESTED,
        data: data,
    }
}